import { useEffect, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '@lib/context/AuthContextType';
import apiClient from '@lib/api/client';
import type { User } from '@/types/Auth.types';

export const PortalCallbackPage = () => {
  const [params] = useSearchParams();
  const ctx = useContext(AuthContext)!;
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const refresh = params.get('refresh');
    if (!token || !refresh) {
      navigate('/portal/login?error=google_failed', { replace: true });
      return;
    }
    // Temporarily store so apiClient can use the token for /portal/me
    localStorage.setItem('accessToken', token);
    localStorage.setItem('refreshToken', refresh);
    apiClient.get('/portal/me')
      .then(res => {
        const user = res.data.data as User;
        ctx.setSession(token, refresh, user);
        navigate(user.role === 'employee' ? '/portal/employee' : '/portal/client', { replace: true });
      })
      .catch(() => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        navigate('/portal/login?error=google_failed', { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-3 border-[#C77D3F] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-gray-500">Signing you in…</p>
      </div>
    </div>
  );
};
